import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { createSEApplicantDetailsValidationSchema } from "../../../../../../yup/common/applicant/applicantDetailsValidationSchema";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import useFormReset from "../../../../../../hooks/useFormReset";
import useStepApplicant from "../../../../../../hooks/useStepApplicant";
import { ApplicationSubtype } from "@duosoftbg/nacid-components";
import SecondaryEduApplicantDetailsForm from "../../../common/form/applicant/SecondaryEduApplicantDetailsForm";
import { initialSEOfficialNoteApplicantDetails } from "../../../../../../init/common/applicantDetailsInitialValues";
import {
  setStepApplicantEdited,
  setRequestIdentifier,
  completeApplicantStep,
} from "../../../../../../store/redux/slice/Forms/seOfficialNoteForm";

const SEOfficialNoteStepApplicant = () => {
  const seOfficialNoteForm = useAppSelector((state) => {
    return state.Forms.SEOfficialNoteForm;
  });

  const { methods, onSubmit } = useStepApplicant(
    seOfficialNoteForm,
    baseEndpointPaths.seRecognition,
    createSEApplicantDetailsValidationSchema,
    setStepApplicantEdited,
    setRequestIdentifier,
    completeApplicantStep,
    initialSEOfficialNoteApplicantDetails,
    false,
    false,
    true,
  );

  useFormReset(ApplicationSubtype.SE_RECOGNITION, seOfficialNoteForm.applicantDetails, methods.reset);

  return <SecondaryEduApplicantDetailsForm methods={methods} onSubmit={onSubmit} hasRepresentativeCompany={true} />;
};
export default SEOfficialNoteStepApplicant;
